import styled from 'styled-components';
import { Grid } from '@mui/material';

import { muiTheme } from '@styles/muiTheme';

export const MenuWrapper = styled.div`
  max-height: 65vh;
  overflow: auto;

  .rc-tree .rc-tree-treenode {
    display: flex;
    align-items: center;
    margin-bottom: 3px;

    .rc-tree-node-selected {
      box-shadow: 0 0 0 0;
      padding-top: 2px;
      border-radius: 4px;
      background: ${muiTheme.palette.primary.light};
      color: ${muiTheme.palette.common.white};
    }

    .rc-tree-node-content-wrapper {
      display: block;
      width: 100%;

      .rc-tree-title {
        display: block;
      }
    }
  }
`;

export const StyledTreeItemTitle = styled(Grid) <{ highlightColor1?: string, disabled?: boolean }>`
  background-color: ${({highlightColor1}) => `${highlightColor1}20`};
  border-radius: 2px;
  cursor: ${({disabled}) => disabled ? 'pointer' : 'default'};
`;